import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import type { OutlookFavoriteKind } from 'owa-favorites-types';

export interface UpdateFavoriteCompletedActionMessage {
    favoriteKind: OutlookFavoriteKind;
}
export const updateFavoriteCompleted: (
    favoriteKind: OutlookFavoriteKind
) => UpdateFavoriteCompletedActionMessage = action(
    'updateFavoriteCompleted',
    (favoriteKind: OutlookFavoriteKind): UpdateFavoriteCompletedActionMessage =>
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!
         *	> Argument at index 1 for addDatapointConfig must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        addDatapointConfig(
            'UpdateFavoriteCompleted',
            undefined,
            {
                customData: {},
            },
            { favoriteKind }
        )
);
